import React from 'react';
import PropTypes from 'prop-types';

import { StyledTermCard, StyledTermCardContent, StyledTermCardActions } from './style';

export const TermCard = (props) => {
    const { actions, children, ...rest } = props;
    return (
        <StyledTermCard variant="outlined" {...rest}>
            <StyledTermCardContent>{children}</StyledTermCardContent>
            <StyledTermCardActions>{actions}</StyledTermCardActions>
        </StyledTermCard>
    );
};

TermCard.propTypes = {
    actions: PropTypes.any,
    children: PropTypes.any,
    rest: PropTypes.object,
};
